<template>
	<div class="pages">
		<navTop></navTop>
		<div class="box">

			<!-- <li>
				<span>108、Continuous working time of inspector (Non-must fill)(For example: and subsequently dates on 13th, 14th, 15th, 16th, 17th, 18th, 19th, 20th,April 2020）
				<p style="color: #fff;"> and subsequently dates on</p>
				</span>
				<span>{{ dataList.jz108 }}</span>
			</li> -->
			<li>
				<span>21、Date
				</span>
				<span>{{ dataList.jz021 }}</span>
			</li>
			<li>
				<span>22、Port and Berth(For example:No.1 of Shengtai）
				</span>
				<span>{{ dataList.jz022 }}</span>
			</li>
			<li>
				<span>23、Nation and Port(For example: Zhangjiagang,P.R.China)
				</span>
				<span>{{ dataList.jz023 }}</span>
			</li>
			<li>
				<span>25、Owners(For example:owners)
				</span>
				<span>{{ dataList.jz025 }}</span>
			</li>

			<li>
				<span>26、Association(Non-must fill)(For example: P & I Club)
				</span>
				<span>{{ dataList.jz026 }}</span>
			</li>
			<li>
				<span>27、Quantity of B/Ls    (For example: 8 B/Ls)
				</span>
				<span>{{ dataList.jz027 }}</span>
			</li>
			<li>
				<span>28、Terminal (For example: Shengtai Terminal)
				</span>
				<span>{{ dataList.jz028 }}</span>
			</li>
			<li>
				<span>29、Name of port(For example: Zhangjiagang)
				</span>
				<span>{{ dataList.jz029 }}</span>
			</li>
			<li>
				<span>30、B/L
				</span>
				<ul class="li12" v-for="(item,index) in dataList.atScheduleNewJz030List">
					<li>
						B/L No.{{item.jz03001}}
					</li>
					<li>
						Cargo Specification{{item.jz03002}}
					</li>
					<li>
						Quantity/ Gross Weight{{item.jz03003}}
					</li>
					<li>
						Mill/Shipper  （Non-must fill）{{item.jz03004}}
					</li>
					<li>
						Loading Port{{item.jz03005}}
					</li>
					<li>
						Discharging Port{{item.jz03006}}
					</li>
				</ul>

			</li>
			<li>
				<span>31、Kind of vessel(For example:Bulk Carrier)
				</span>
				<span>{{ dataList.jz031 }}</span>
			</li>
			<li>
				<span>32、Port of Registry
				</span>
				<span>{{ dataList.jz032 }}</span>
			</li>
			<li>
				<span>33、Call Sign
				</span>
				<span>{{ dataList.jz033 }}</span>
			</li>
			<li>
				<span>34、IMO No
				</span>
				<span>{{ dataList.jz034 }}</span>
			</li>
			<li>
				<span>35、Classification(Non-must fill)
				</span>
				<span>{{ dataList.jz035 }}</span>
			</li>
			<li>
				<span>36、Year/Place Built(For example:2005/Zhenjiang Shipyard)
				</span>
				<span>{{ dataList.jz036 }}</span>
			</li>
			<li>
				<span>37、LOA/ Breath/Depth(For example: 189.99m/32.26m/17.20m)
				</span>
				<span>{{ dataList.jz037 }}</span>
			</li>
			<li>
				<span>38、Gross/ Net Tonnage
				</span>
				<span>{{ dataList.jz038 }}</span>
			</li>
			<li>
				<span>39、Owner(Non-must fill)
				</span>
				<span>{{ dataList.jz039 }}</span>
			</li>
			<li>
				<span>40、Managers(Non-must fill)
				</span>
				<span>{{ dataList.jz040 }}</span>
			</li>
			<li>
				<span>41、Date of berthing time(For example: 1900hrs on 13-Apr-2020) )
				</span>
				<span>{{ dataList.jz041 }}</span>
			</li>
			<li>
				<span>42、Time and date of completion of port entry    (For example: 1900hrs on 13-Apr-2020)
				</span>
				<span>{{ dataList.jz042 }}</span>
			</li>
			<li>
				<span>43、Quantity of cargo hold (For example:5)
				</span>
				<span>{{ dataList.jz043 }}</span>
			</li>
			<li>
				<span>44、Quantity and type of Hatch cover     (For example: 5 Macgregor EI. Hydraulic folding)
				</span>
				<span>{{ dataList.jz044 }}</span>
			</li>
			<li>
				<span>45、Year of build     (For example: 2005)
				</span>
				<span>{{ dataList.jz045 }}</span>
			</li>
			<li>
				<span>46、Load of ship's crane  （Non-must fill）    (For example: SWL=35MT)
				</span>
				<span>{{ dataList.jz046 }}</span>
			</li>
			<li>
				<span>47、Whether hatch cover in normal or not
				</span>
				<span v-if="dataList.jz047!='normal'">{{ dataList.jz04701 }}</span>
				<span v-else>{{dataList.jz047}}</span>
			</li>
			<li>
				<span>48、Whether rubber gaskets of the hatch covers in normal or not
				</span>
				<span v-if="dataList.jz048!='normal'">{{ dataList.jz04801 }}</span>
				<span v-else>{{dataList.jz048}}</span>
			</li>
			<li>
				<span>49、The compression bars and the hatch coamings were
				</span>
				<span v-if="dataList.jz049!='straight'">{{ dataList.jz04901 }}</span>
				<span v-else>{{dataList.jz049}}</span>
			</li>
			<li>
				<span>50、Whether compression bars and the hatch coaming in satisfctory or not
				</span>
				<span v-if="dataList.jz050!='satisfactory'">{{ dataList.jz05001 }}</span>
				<span v-else>{{dataList.jz050}}</span>
			</li>
			<li>
				<span>51、Whether gutter ways and drain hole were clean or not
				</span>
				<span v-if="dataList.jz051!='clean'">{{ dataList.jz05101 }}</span>
				<span v-else>{{dataList.jz051}}</span>
			</li>
			<li>
				<span>52、Whether non-return valves in good condition or not
				</span>
				<span v-if="dataList.jz052!='sound'">{{ dataList.jz05201 }}</span>
				<span v-else>{{dataList.jz052}}</span>
			</li>
			<li>
				<span>53、Whether cleats workable or not
				</span>
				<span v-if="dataList.jz053!='workable'">{{ dataList.jz05301 }}</span>
				<span v-else>{{dataList.jz053}}</span>
			</li>
			<li>
				<span>54、Degree of rust on tanktop
				</span>
				<span v-if="dataList.jz054=='rusty'">{{ dataList.jz05401 }}</span>
				<span v-else>{{dataList.jz054}}</span>
			</li>
			<li>
				<span>55、Wether bilge well covered or not
				</span>
				<span v-if="dataList.jz055!='covered'">{{ dataList.jz05501 }}</span>
				<span v-else>{{dataList.jz055}}</span>
				<!-- <p style="color: #fff;">{{ dataList.jz05501 }}</p> -->
			</li>
			<li>
				<span>56、Quantity of total B/Ls loaded onboard(For example: 6 B/Ls)
				</span>
				<span>{{dataList.jz056}}</span>
				<!-- <p style="color: #fff;">{{ dataList.jz05501 }}</p> -->
			</li>
			<li>
				<span>57、Description of the cargo condition of pre-shipment
				</span>
				<ul class="li12" v-for="(item,index) in dataList.atScheduleNewJz057List">
					<li>
						57、B/L No.(For example: HTZJGJUR02)
						<p>
							{{item.jz057}}
						</p>
					</li>
					<li>
						58、The name of cargo under the B/L(For example:Hot Rolled Deformed Bars)
						<p>{{item.jz058}}</p>
					</li>
					<li>
						59、Quantity and weight of cargo under the B/L(For example:1,542Bundles/3,067.522MT)
						<p>
							{{item.jz059}}
						</p>
					</li>
					<li>
						60、Description of the cargo condition under the B/L(For example:1.All the cargo was stacked in warehouse with coverage.2.Scratched on the surface slightly, affected all3.Rust on the surface slightly, affected all4.1~2 pcs strapping bands broken/missing, affected 41 bundles）
						<p>
							{{item.jz060}}
						</p>
					</li>

				</ul>

			</li>

			<li>
				<span>
					61、
				</span>
				<ul class="li12" v-for="(item,index) in dataList.atScheduleNewJz061List">
					<li>
						Number and quantity of each cargo hold loaded(For example:1)
						<p>
							{{item.jz06101}}
						</p>
					</li>
					<li>
						Tons(MT）
						<p>
							{{item.jz06102}}
						</p>
					</li>
				</ul>
			</li>

			<li>
				<span>
					62、Date and time of commence loading operation(For example:1900hrs on 13-Apr-2020）
				</span>
				<span>{{dataList.jz062}}</span>
			</li>
			<li>
				<span>
					63、Cargo hold No.of designated cargo hold to be load (For example:Hold No.2, No.3, No.4 and No. 5 ect)
				</span>
				<span>{{dataList.jz063}}</span>
			</li>
			<li>
				<span>
					64、Name of cargo loaded onboard(Non-must fill)
				</span>
				<!-- <span>{{dataList.jz064}}</span> -->
				<ul v-if="dataList.jz064!='Nothing'&dataList.jz064" class="li12">
					<li>
						<p>
							Tool of transportation from warehouse/openyard to shipside  (For example:via trailers）
						</p>
						<p>
							{{dataList.jz06401}}
						</p>
					</li>
					<li>
						<p>
							Kind of crane lifted cargo(For example:shore crane)
						</p>
						<p>
							{{dataList.jz06402}}
						</p>
					</li>
					<li>
						<p>
							Quantity of each sling(For example:8-10 bundles)
						</p>
						<p>
							{{dataList.jz06403}}
						</p>
					</li>
					<li>
						<p>
							Number of cargo hold for loading  (For example:No.4 ect)
						</p>
						<p>
							{{dataList.jz06404}}
						</p>
					</li>
					<li>
						<p>
							Kind of sling(For example:steel chain or steel wire)
						</p>
						<p>
							{{dataList.jz06405}}
						</p>
					</li>
					<li>
						<p>
							Tool of stow in cargo hold(For example:forklift)
						</p>
						<p>
							{{dataList.jz06406}}
						</p>
					</li>
					<li>
						<p>
							Quantity of dunnage on tanktop before loading(For example:6 lines)
						</p>
						<p>
							{{dataList.jz06407}}
						</p>
					</li>
					<li>
						<p>
							Size of dunnage(For example:8cmx8cm)
						</p>
						<p>
							{{dataList.jz06408}}
						</p>
					</li>
					<li>
						<p>
							Quantity of steel wire rope for lashing underneath cargo  (For example:3 lines）
						</p>
						<p>
							{{dataList.jz06409}}
						</p>
					</li>
					<li>
						<p>
							Additional remarks(Non-must fill)
						</p>
						<p>
							{{dataList.jz06410}}
						</p>
					</li>
				</ul>
				<span v-else>{{dataList.jz064}}</span>
			</li>

			<li>
				<span>
					65、Name of cargo loaded onboard(Non-must fill)
				</span>
				<!-- <span>{{dataList.jz065}}</span> -->
				<ul v-if="dataList.jz065!='Nothing'" class="li12">
					<li>
						<p>
							Tool of transportation from warehouse/open yard to shipside   (For example:via trailers）
						</p>
						<p>
							{{dataList.jz06501}}
						</p>
					</li>
					<li>
						<p>
							Tool shift cargo on quay side(For example: forklift）
						</p>
						<p>
							{{dataList.jz06502}}
						</p>
					</li>
					<li>
						<p>
							Kind of crane lifted cargo(For example:shore crane)
						</p>
						<p>
							{{dataList.jz06503}}
						</p>
					</li>
					<li>
						<p>
							Quantity of each sling(For example:8-10 bundles)
						</p>
						<p>
							{{dataList.jz06504}}
						</p>
					</li>
					<li>
						<p>
							Number of cargo hold for loading (For example:No.4 ect)
						</p>
						<p>
							{{dataList.jz06505}}
						</p>
					</li>
					<li>
						<p>
							Kind of sling(For example:steel chain or steel wire)
						</p>
						<p>
							{{dataList.jz06506}}
						</p>
					</li>
					<li>
						<p>
							Stowage condition (Non-must fill)(For example:The wire rods were stowed longitudinally and tiers by tiers in the fore and after of holds.)
						</p>
						<p>
							{{dataList.jz06507}}
						</p>
					</li>
					<li>
						<p>
							Additional remarks:(Non-must fill)
						</p>
						<p>
							{{dataList.jz06508}}
						</p>
					</li>

				</ul>
				<span v-else>{{dataList.jz065}}</span>
			</li>

			<li>
				<span>
					66、Name of cargo loaded onboard(Non-must fill)
				</span>
				<!-- <span>{{dataList.jz065}}</span> -->
				<ul v-if="dataList.jz066!='Nothing'&dataList.jz066" class="li12">
					<li>
						<p>
							The place cargoes stored(in warehouse/on openyard)
						</p>
						<p>
							{{dataList.jz06601}}
						</p>
					</li>
					<li>
						<p>
							Tool of transportation from warehouse/open yard to shipside
						</p>
						<p>
							{{dataList.jz06602}}
						</p>
					</li>
					<li>
						<p>
							Kind of crane lifted cargo
						</p>
						<p>
							{{dataList.jz06603}}
						</p>
					</li>
					<li>
						<p>
							Hook  type(For example:“c”-Hook ）
						</p>
						<p>
							{{dataList.jz06604}}
						</p>
					</li>
					<li>
						<p>
							Quantity of each sling(For example:2-5pcs per sling)
						</p>
						<p>
							{{dataList.jz06605}}
						</p>
					</li>
					<li>
						<p>
							Quantity of dunnage on tanktop before loading  (For example:3-4 lines)
						</p>
						<p>
							{{dataList.jz06606}}
						</p>
					</li>
					<li>
						<p>
							Size of dunnage(For example:(4cm*6cm*1m) ）
						</p>
						<p>
							{{dataList.jz06607}}
						</p>
					</li>
					<li>
						<p>
							Number of cargo hold for loading (For example:No.1 and No.4 ect)
						</p>
						<p>
							{{dataList.jz06608}}
						</p>
					</li>
					<li>
						<p>
							Quantity of lines (For example:4 lines）
						</p>
						<p>
							{{dataList.jz06609}}
						</p>
					</li>
					<li>
						<p>
							Quantity of rows (For example:5 rows）
						</p>
						<p>
							{{dataList.jz06610}}
						</p>
					</li>
					<li>
						<p>
							Pieces per row  (For example:4 pcs）
						<p>
							{{dataList.jz06611}}
						</p>
					</li>
					<li>
						<p>
							The height of the cargo stowed(For example:1.2meter）
						<p>
							{{dataList.jz06612}}
						</p>
					</li>
					<li>
						<p>
							Quantity of lashing wire rope/ steel strapping band for per pile (For example:2 steel ）
						<p>
							{{dataList.jz06613}}
						</p>
					</li>
					<li>
						<p>
							Wire rope / steel strapping band
						<p>
							{{dataList.jz06614}}
						</p>
					</li>
					<li>
						<p>
							Additional remarks(Non-must fill)
						<p>
							{{dataList.jz06615}}
						</p>
					</li>

				</ul>
				<span v-else>{{dataList.jz066}}</span>
			</li>
			<li>
				<span>
					67、Name of cargo loaded onboard(Non-must fill)
				</span>
				<div v-if="dataList.jz067!='Nothing'">
					<ul class="li12">
						<li>
							<p>Tool of transportation from warehouse/open yard to shipside</p>
							<p>
								{{dataList.jz06701}}
							</p>
						</li>
						<li>
							<p>The place cargoes stored(in warehouse/on openyard)</p>
							<p>
								{{dataList.jz06702}}
							</p>
						</li>
						<li>
							<p>Kind of crane lifted cargo</p>
							<p>
								{{dataList.jz06703}}
							</p>
						</li>
						<li>
							<p>Quantity of each sling (For example:2-5pcs per sling)</p>
							<p>
								{{dataList.jz06704}}
							</p>
						</li>
					</ul>
					<ul class="li12" v-for="(item,index) in dataList.atScheduleNewJz067List">
						<li>
							<P>
								Number of cargo hold for loading (For example:No.1）
							</P>
							<P>
								{{item.jz06705}}
							</P>
						</li>
						<li>
							<P>
								Quantity of cargo loaded (For example:98 coils)
							</P>
							<P>
								{{item.jz06706}}
							</P>
						</li>
						<li>
							<P>
								Quantity of rows  (For example:10 rows）
							</P>
							<P>
								{{item.jz06707}}
							</P>
						</li>
						<li>
							<P>
								Position the cargo loaded in hold
							</P>
							<P>
								{{item.jz06708}}
							</P>
						</li>
						<li>
							<P>
								Quantity of tiers   (For example:2 tiers）
							</P>
							<P>
								{{item.jz06709}}
							</P>
						</li>
					</ul>
				</div>
				<span v-else>
					{{dataList.jz067}}
				</span>
			</li>
			<li>
				<span>
					68、Name of cargo loaded onboard(Non-must fill)
				</span>
				<!-- <span>{{dataList.jz065}}</span> -->
				<ul v-if="dataList.jz068!='Nothing'" class="li12">
					<li>
						<p>
							Number of loads per crane(For example:1-2pcs)
						</p>
						<p>
							{{dataList.jz06801}}
						</p>
					</li>
					<li>
						<p>
							Tool of transportation from warehouse/open yard to shipside
						</p>
						<p>
							{{dataList.jz06802}}
						</p>
					</li>
					<li>
						<p>
							Shifted tool in warehouse/on openyard(For example:forklift)
						</p>
						<p>
							{{dataList.jz06803}}
						</p>
					</li>
					<li>
						<p>
							Kind of crane lifted cargo
						</p>
						<p>
							{{dataList.jz06804}}
						</p>
					</li>
					<li>
						<p>
							Quantity of tiers  (For example:2 tiers )
						</p>
						<p>
							{{dataList.jz06805}}
						</p>
					</li>
					<li>
						<p>
							Quantity of strapping bands for coils against port/starboard plate   (For example: 2 pcs of steel lashing bands）
						</p>
						<p>
							{{dataList.jz06806}}
						</p>
					</li>
					<li>
						<p>
							Quantity of strapping bands for key coils and adjacent coils (For example: 2 pcs of steel lashing bands  )
						</p>
						<p>
							{{dataList.jz06807}}
						</p>
					</li>
					<li>
						<p>
							Quantity of strapping bands for other coils in line (For example: 2 pcs of steel lashing bands）
						</p>
						<p>
							{{dataList.jz06808}}
						</p>
					</li>
					<li>
						<p>
							Quantity of dunnage on tanktop before loading(For example: 2-3 rows )
						</p>
						<p>
							{{dataList.jz06809}}
						</p>
					</li>
					<li>
						<p>
							Size of dunnage(For example:3cmx5cmx80cm)
						</p>
						<p>
							{{dataList.jz06810}}
						</p>
					</li>
					<li>
						<p>
							Additional remarks(Non-must fill)
						</p>
						<p>
							{{dataList.jz06811}}
						</p>
					</li>


				</ul>
				<span v-else>{{dataList.jz068}}</span>
			</li>
			<li>
				<span>
					69、Other cargo  ( Non-must fill )
				</span>
				<span>
					{{dataList.jz069}}
					<p>
					{{dataList.jz06901}}
					</p>
				</span>
			</li>
			<li>
				<span>
					70、Till date and time of tally report(For example:0800hrs on 24-Nov-2015)
				</span>
				<span>
					{{dataList.jz070}}
				</span>
			</li>
			<li>
				<span>
					71、The quanlity and tons of daily report(For example:1,567 Packages / 3,430 Mts)
				</span>
				<span>
					{{dataList.jz071}}
				</span>
			</li>
			<li>
				<span>
					72、Estimated loading completion time
				</span>
				<span>
					{{dataList.jz072}}
				</span>
			</li>
			<li>
				<span>
					73、The detail quanlity and tons of daily report for each cargo hold
				</span>
				<ul class="li12" v-for="(item,index) in dataList.atScheduleNewJz073List">
					<li>
						<p>
							Hold No.
						</p>
						<p>
							{{item.jz07301}}
						</p>
					</li>
					<li>
						<p>
							Description
						</p>
						<p>
							{{item.jz07302}}
						</p>
					</li>
					<li>
						<p>
							Packages
						</p>
						<p>
							{{item.jz07303}}
						</p>
					</li>
					<li>
						<p>
							Weight(Mt)
						</p>
						<p>
							{{item.jz07304}}
						</p>
					</li>
				</ul>
			</li>
			<li>
				<span>
					74、Date of loading operation
				</span>
				<span>
					{{dataList.jz074}}
				</span>
			</li>
			<li>
				<span>
					75、Loading suspended time due to rain(For example:at 0045~0340LT on24-Nov-2015)
				</span>
				<span>
					{{dataList.jz075}}
				</span>
			</li>
			<li>
				<span>
					76、Temperature and weather(For example: 14℃~18℃, shower）
				</span>
				<span>
					{{dataList.jz076}}
				</span>
			</li>
			<li>
				<span>77、Signature of the surveyor/inspector</span>
				<img style="background: #fff;" :src="dataList.jz077" />
			</li>
			<li>
				<span>
					123、The date of the daily port
				</span>
				<span>
					{{dataList.jz123}}
				</span>
			</li>
			<li>
				<span>78、Photoes of Vessel's condition before shipment</span>
				<div v-if="dataList.jz078" style="display: flex;">
					<img v-for="(item,index) in dataList.jz078.split('|')" :src="item" />
				</div>

			</li>
			<li>
				<span>15、Photo of the cargo condition before loading</span>
				<div v-if="dataList.jz015" style="display: flex;">
					<img v-for="(item,index) in dataList.jz015.split('|')" :src="item" />
				</div>

			</li>
			<li>
				<span>16、 Photoes of loading operation</span>
				<div v-if="dataList.jz016" style="display: flex;">
					<img v-for="(item,index) in dataList.jz016.split('|')" :src="item" />
				</div>

			</li>
			<li>
				<span>17、 Photoes of dunnage</span>
				<div v-if="dataList.jz017" style="display: flex;">
					<img v-for="(item,index) in dataList.jz017.split('|')" :src="item" />
				</div>

			</li>
			<li>
				<span>18、Cargo stowage condition in cargo hold</span>
				<div v-if="dataList.jz018" style="display: flex;">
					<img v-for="(item,index) in dataList.jz018.split('|')" :src="item" />
				</div>

			</li>

		</div>
	</div>
</template>

<script>
import navTop from '../../components/navTop.vue';
import pdf from 'vue-pdf';
export default {
	name: 'ly',
	components: {
		navTop,
		pdf
	},
	data() {
		return {
			dataList: {},
			num: ''
		};
	},
	created() {
		if (!sessionStorage.getItem('uid')) {
			this.$router.push({ path: '/' });
		} else {
			this.id = this.$route.query.id;
			this.getSchedulely(this.$route.query.scheduleId);
		}
	},
	methods: {
		getSchedulely(scheduleId) {
			let data = {
				id: this.id,
				scheduleId:scheduleId
			};
			this.$api.rb(data).then(res => {
				console.log(res);
				if (res.result == 0) {
					this.dataList = res.data;
					// if (res.data.ly026) {
					// 	if (this.getSuffix(res.data.ly026) == 'pdf') {
					// 		this.num = 1;
					// 	} else {
					// 		this.num = 0;
					// 	}
					// }
				}
			});
		},
		// 截取后缀名
		getSuffix(str) {
			var index = str.lastIndexOf('.');
			return str.substr(index + 1);
		}
	}
};
</script>

<style lang="scss" scoped>
	.li12 li p{color: #fff !important}
	.li12 li{color: #fff !important}
	p{color: #fff !important}
.pages {
	background: #3E414A;
	.box {
		margin: 50px auto;
		border: 1px solid rgba(0, 255, 255, 0.25);
		border-radius: 10px;
		padding: 45px 154px 38px 56px;
		box-sizing: border-box;
		box-shadow: 0 0 300px 100px #043138 inset;
		li {
			display: flex;
			flex-direction: column;
			padding-bottom: 20px;
			box-sizing: border-box;
			span:nth-child(1) {
				color: #00fff0;
				font-size: 24px;
				line-height: 1em;
			}
			span:nth-child(2) {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			a {
				font-size: 24px;
				color: #ffffff;
				line-height: 1em;
				padding-top: 15px;
				box-sizing: border-box;
			}
			img {
				margin-top: 15px;
				display: block;
				width: 392px;
				height: 292px;
				border-radius: 10px;
			}
		}
	}
}
</style>
